var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { computed, makeObservable } from 'mobx';
import { sortedSet } from '../../../../utils/mobx/decorators/customComputed';
import { Actor_ } from '../../../../components/actor/Actor_';
import { runtime } from '../../../runtime/Runtime';
export class AspectJsx {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    /* TAG NAME */
    get jsxTagString() {
        return this.jsxComponentType(undefined);
    }
    jsxComponentType(templateComponent) {
        const { jsxTag } = this.aspect.valueOf;
        if (jsxTag)
            return jsxTag;
        if (templateComponent) {
            return templateComponent.type;
        }
        return 'div';
    }
    /* ATTRIBUTES */
    get jsxAttributes() {
        const jsxAttributes = { key: this.aspect.name };
        for (const key of this.aspect.aspectEvents.observedEvents.activeEventHandlerKeys) {
            jsxAttributes[key] = this.aspect.aspectEvents.eventReception.handleReactEvent;
        }
        const x = mergeJsxObjects(jsxAttributes, this.jsxAttributes_cssAndStyle, this.jsxAttributes_fromTraits);
        /*
        if (this.aspect.readableIdentifier.includes('prefix')) {
          console.log('jsxAttributes', this.aspect.readableIdentifier, { ...x });
        }
    */
        return x;
    }
    get jsxAttributes_cssAndStyle() {
        /*
          aspect_${this.aspect.id} needed for generated animation intensity styles
             z.B.      .aspect_xsdVPx {
              --au: calc(var(--su) * 569 / 100);
              --ai: calc(569 / 100);
            }
    
           */
        return {
            className: `${this.aspect.actor.type}_${this.aspect.name} aspect_${this.aspect.id} ${this.aspect.aspectClassNames.classNamesAsString}`,
            style: this.aspect.css,
        };
    }
    get jsxAttributes_fromTraits() {
        const obj = {};
        const source = this.aspect.global.aspectActive.activeValuesObject;
        for (const key in source) {
            if (key.startsWith(`jsx_${this.jsxTagString}_`) || key.startsWith('jsx_attr_')) {
                const setkey = key.replace(`jsx_${this.jsxTagString}_`, '').replace('jsx_attr_data_', 'jsx_attr_data-').replace('jsx_attr_', '');
                obj[setkey] = source[key];
            }
        }
        return obj;
    }
    get jsxChildren_fromTraits() {
        const contentComponents = this.aspect.aspectContent.global.activeContentAts
            .map(at => {
            if (at instanceof runtime.class.AttachedContent) {
                return React.createElement(Actor_, { actor: at, key: at.trait.id });
            }
            if (!at.trait.value)
                return undefined;
            if (at.key === 'childFromAspectName') {
                return (React.createElement(Actor_, { actor: at.aspect.actor, key: at.trait.id, structureTemplate: React.createElement("div", { "data-aspect": at.trait.value, "data-contenttraitid": at.trait.id }) }));
            }
            if (at.key === 'childFromSkeleton') {
                return at.componentResultingFromAttachedTrait;
            }
            return undefined;
        })
            .filter(c => c);
        return contentComponents;
    }
}
__decorate([
    computed
], AspectJsx.prototype, "jsxTagString", null);
__decorate([
    computed.struct
], AspectJsx.prototype, "jsxAttributes", null);
__decorate([
    computed.struct
], AspectJsx.prototype, "jsxAttributes_cssAndStyle", null);
__decorate([
    computed.struct
], AspectJsx.prototype, "jsxAttributes_fromTraits", null);
__decorate([
    sortedSet
], AspectJsx.prototype, "jsxChildren_fromTraits", null);
export function mergeJsxObjects(first, ...sources) {
    const result = first;
    for (let i = 0; i < sources.length; i++) {
        const source = sources[i];
        const keys = Object.keys(source);
        for (let j = 0; j < keys.length; j++) {
            const key = keys[j];
            result[key] = mergeJsxAttributes(result[key], source[key], key);
        }
    }
    return result;
}
function mergeJsxAttributes(objVal, srcVal, key) {
    if (['className'].includes(key)) {
        if (objVal && !srcVal)
            return objVal;
        if (!objVal && srcVal)
            return srcVal;
        return `${objVal} ${srcVal}`;
    }
    if (['style'].includes(key)) {
        let s = srcVal;
        if (typeof s === 'string') {
            try {
                s = new Function(`return ${s}`)();
            }
            catch (e) {
                console.log(`jsonERROR in ${key}`, e);
            }
        }
        return Object.assign({}, objVal, s);
    }
    if (key.startsWith('on') && (typeof objVal === 'function' || typeof srcVal === 'function')) {
        if (!objVal)
            return srcVal;
        if (!srcVal)
            return objVal;
        return e => {
            objVal(e);
            srcVal(e);
        };
    }
    return srcVal;
}
